import { applyCspNonceToElement } from './getCspNonce';

/**
 * style-loader "insert" hook.
 * Sets CSP nonce on the <style> element BEFORE insertion.
 */
export default function insertStyleWithNonce(element) {
  try {
    applyCspNonceToElement(element);
  } catch (_) {
    // If DOM isn't available yet, fall back to default insertion without nonce.
  }

  const parent = document.head || document.getElementsByTagName('head')[0];
  if (parent) parent.appendChild(element);
}
